import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import axios from "axios";
import { format } from "date-fns";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../Context/UserContextAPI";
import AgencySummaryModal from "../../../components/Modal/RegistrationSummaryModal/AgencySummaryModal";
import CountrySummaryModal from "../../../components/Modal/RegistrationSummaryModal/CountrySummaryModal";
import PackageSummaryModal from "../../../components/Modal/RegistrationSummaryModal/PackageSummaryModal";
import RepresentativeSummeryModal from "../../../components/Modal/RegistrationSummaryModal/RepresentativeSummaryModal";
import "../PatientInformation/PatientInformationCopy.scss";
import Select from "react-select";
import VirtualizedMenuList from "../../../components/VirtualMenuList/VirtualMenuList";
import Loading from "../../../utils/Loader/Loading";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const PreRegistration = () => {
  const { accessPerm, introducerUsers } = useContext(UserContext);
  const [userDetails, setUserDetails] = useState([]);
  const [countryWiseUsers, setCountryWiseUsers] = useState([]);
  const [introducerWiseUsers, setIntroducerWiseUsers] = useState([]);
  const [packageWiseUsers, setPackageWiseUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [representativeWiseUsers, setRepresentativeWiseUsers] = useState([]);
  const [selectedValues, setSelectedValues] = useState({
    introducer: null,
    country: null,
    company: null,
    delegate: null,
  });

  const [regInputField, setRegInputField] = useState("");
  const [statusCounts, setStatusCounts] = useState({
    status1: 0,
    status2: 0,
    status3: 0,
    status4: 0,
  });
  const pdfRef = useRef();

  const [totalStatus, setTotalStatus] = useState(0);
  const [otherStatus, setOtherStatus] = useState(0);

  const navigate = useNavigate();

  const options = [
    { value: "", label: "Select Introducer" },
    ...introducerUsers.map((user) => {
      const representativeMobile =
        user?.user_users_maps[0]?.representative_user_map?.mobile;

      const mobileLabel = representativeMobile
        ? `(${representativeMobile.slice(-2)})`
        : "(Not Assigned)";

      return {
        value: parseInt(user?.id),
        label: `${user?.registration_no} - ${user?.f_name} - ${mobileLabel}`,
      };
    }),
  ];

  const handlerOnSearch = (e) => {
    e.preventDefault();

    const form = e.target;
    const fromDate = form.from_date.value;
    const toDate = form.to_date.value;
    const status = form.status.value;
    const introducer = form.introducer.value;
    const country = "";
    const company = "";
    const delegate = "";
    const regNo = form.invoice_reg_mobile.value;

    const filterData = {
      fromDate,
      toDate,
      status,
      introducer,
      country,
      company,
      delegate,
      regNo: regNo.trim(),
    };
    methodFilterPatientsDetails(filterData, "form");
  };

  const methodFilterPatientsDetails = async (filterData, form) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user-details/pre-reg/search`,
        filterData,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      );

      const data = response?.data;
      if (data) {
        calculateStatus(data?.userDetails);

        if (data?.userDetails) {
          const sortData = data?.userDetails.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUserDetails(sortData ? sortData : data?.userDetails);
        }
        setCountryWiseUsers(data?.countryWiseUser);
        setPackageWiseUsers(data?.packageWiseUser);
        setIntroducerWiseUsers(data?.introducerWiseUser);
        setRepresentativeWiseUsers(data?.representativeWiseUser);
        setTotalStatus(data?.userDetails?.length);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSelect = (name, selectedOptions) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [name]: selectedOptions,
    }));
  };

  const calculateStatus = (data) => {
    const counts = {
      status1: 0,
      status2: 0,
      status3: 0,
      status4: 0,
    };
    let notDoneCount = 0;

    data.forEach((userInfo) => {
      const collection = userInfo?.user?.user_collections?.map(
        (collection) =>
          collection.investigation_category?.investigation_group_id
      );

      const uniqueCollection = [...new Set(collection)];
      const done =
        (uniqueCollection?.length < 2 &&
          (userInfo?.user?.is_pathology_done ? 1 : 0) +
            (userInfo?.user?.is_physical_done ? 1 : 0) +
            (userInfo?.user?.is_radiology_done ? 1 : 0) <
            2) ||
        (uniqueCollection?.length >= 2 &&
          uniqueCollection?.length < 3 &&
          (userInfo?.user?.is_pathology_done ? 1 : 0) +
            (userInfo?.user?.is_physical_done ? 1 : 0) +
            (userInfo?.user?.is_radiology_done ? 1 : 0) >=
            2) ||
        (uniqueCollection?.length >= 3 &&
          userInfo?.user?.is_pathology_done &&
          userInfo?.user?.is_physical_done &&
          userInfo?.user?.is_radiology_done);

      // Counting entries where the task is not done
      if (!done || userInfo?.user?.status === 1) {
        notDoneCount++;
      }

      switch (userInfo?.user?.status) {
        case 1:
          counts.status1 = counts.status1 + 1;
          break;
        case done && 2:
          counts.status2 = counts.status2 + 1;
          break;
        case done && 3:
          counts.status3 = counts.status3 + 1;
          break;
        case done && 4:
          counts.status4 = counts.status4 + 1;
          break;
        default:
          break;
      }
    });

    setStatusCounts(counts);
    setTotalStatus(userDetails?.length);
    setOtherStatus(notDoneCount);
  };

  const getUserDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user-details/prereg`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      );
      console.log(response);
      const data = response?.data?.data;
      if (data?.userDetails?.length !== 0) {
        if (data?.userDetails) {
          const sortData = data?.userDetails.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUserDetails(sortData ? sortData : data?.userDetails);
        }
        setCountryWiseUsers(data?.countryWiseUser);
        setPackageWiseUsers(data?.packageWiseUser);
        setIntroducerWiseUsers(data?.introducerWiseUser);
        setRepresentativeWiseUsers(data?.representativeWiseUser);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const pdfGenerate = () => {
    const input = pdfRef.current;
    const doc = new jsPDF("p", "mm");

    const tableOptions = {
      theme: "grid",
      margin: {
        left: 10,
        right: 10,
      },
      styles: {
        fontSize: 9,
        halign: "center",
        valign: "middle",
        cellPadding: 1,
      },
      columnStyles: {
        0: {
          cellWidth: 8,
        },
        1: {
          cellWidth: 30,
        },
        2: {
          cellWidth: 45,
        },
        3: {
          cellWidth: 45,
        },
        4: {
          cellWidth: 30,
        },
        5: {
          cellWidth: 30,
        },
      },
      headStyles: {
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
    };

    const addContentToPage = () => {
      // Set a fixed row height for each row
      const rowHeight = 20;

      autoTable(doc, {
        html: input,
        columns: [
          { header: "SL", dataKey: "SL" },
          { header: "Date", dataKey: "createdAt" },
          { header: "Passenger Name", dataKey: "user.f_name" },
          { header: "Agency", dataKey: "introducer_user.f_name" },
          { header: "Country", dataKey: "country.shortname" },
          { header: "Type", dataKey: "user.role.name" },
        ],
        startY: 20,
        ...tableOptions,
        rowPageBreak: "avoid",
        margin: {
          top: 0,
          left: 10,
          right: 10,
        },
        bodyStyles: {
          rowHeight: rowHeight,
        },
      });
    };

    addContentToPage();
    doc.save("Pre-Registration.pdf");
  };

  const handlePDF = async () => {
    pdfGenerate();
  };

  const reset = (e) => {
    const form = e.target.form;
    try {
      const currentDate = new Date();
      const formattedDate = format(currentDate, "yyyy-MM-dd");

      const filterData = {
        fromDate: formattedDate,
        toDate: formattedDate,
        status: "",
        introducer: "",
        country: "",
        company: "",
        delegate: "",
        regNo: "",
      };

      methodFilterPatientsDetails(filterData, form);
      form.reset();
      setSelectedValues({
        introducer: null,
        country: null,
        company: null,
        delegate: null,
      });

      setRegInputField("");
    } catch (error) {
      console.error(error);
    }
  };

  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => [
      columnHelper.accessor("SL.", {
        header: () => (
          <div className="text-center">
            <span className="text-center px-2">SL</span>
          </div>
        ),
        cell: (info) => {
          const reversedSerialNumber = userDetails?.length - info?.row?.id;

          return (
            <div className="text-left fw-bold">
              <span className="text-center text-dark" style={{ color: "#000" }}>
                {reversedSerialNumber}
              </span>
            </div>
          );
        },
      }),

      columnHelper.accessor("createdAt", {
        header: () => (
          <span className="d-flex justify-content-center">Date</span>
        ),
        cell: (info, index) => {
          const reversedIndex = userDetails.length - index - 1;
          const dateValue = new Date(info.renderValue(reversedIndex));
          const formattedDate = format(dateValue, "dd-MM-yyyy");

          return (
            <div
              className="d-flex justify-content-start text-dark"
              style={{ color: "#000" }}
            >
              {formattedDate}
            </div>
          );
        },
      }),
      columnHelper.accessor("user.f_name", {
        header: () => (
          <span className="text-center d-flex justify-content-center">
            Passenger Name
          </span>
        ),
        cell: (info) => {
          return (
            <div
              className="d-flex justify-content-start text-dark"
              style={{ color: "#000" }}
            >
              {info.getValue()}
            </div>
          );
        },
      }),

      columnHelper.accessor("introducer_user.f_name", {
        header: () => (
          <span className="text-center d-flex justify-content-center">
            Agency
          </span>
        ),
        cell: (info) => {
          info.getValue();
          const value1 = info.getValue();
          const representative_Mob =
            info?.row?.original?.introducer_user?.user_users_maps[0]?.representative_user_map?.mobile?.slice(
              -2
            );

          return (
            <div>
              {representative_Mob ? (
                <span
                  className="text-center d-flex justify-content-start text-dark"
                  style={{ color: "#000" }}
                >
                  {value1} - ({representative_Mob})
                </span>
              ) : (
                <span
                  className="text-center d-flex justify-content-start text-dark"
                  style={{ color: "#000" }}
                >
                  {value1}
                </span>
              )}
            </div>
          );
        },
      }),

      columnHelper.accessor("country.shortname", {
        header: () => (
          <span className="text-center d-flex justify-content-center">
            Country
          </span>
        ),
        cell: (info) => {
          return (
            <div
              className="d-flex justify-content-start text-dark"
              style={{ color: "#000" }}
            >
              {info.getValue()}
            </div>
          );
        },
      }),

      columnHelper.accessor("user.role.name", {
        header: () => (
          <span className="text-center d-flex justify-content-center">
            Type
          </span>
        ),
        cell: (info) => {
          return (
            <div
              className="d-flex justify-content-start text-dark"
              style={{ color: "#000" }}
            >
              {info.getValue()}
            </div>
          );
        },
      }),
      columnHelper.accessor("actions", {
        id: "Actions",
        header: () => (
          <span className="text-center d-flex justify-content-center">
            Actions
          </span>
        ),
        cell: ({ row: { original } }) => {
          return (
            <div className="d-flex justify-content-start">
              {/* View User Details Trigger Button */}
              {accessPerm(72, 5) && (
                <button
                  type="button"
                  title="Preview"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={() =>
                    navigate("/dashboard/profile", {
                      state: { data: original },
                    })
                  }
                  className="btn btn-warning btn-sm"
                  style={{ marginRight: "5px" }}
                >
                  <i className="fa-regular fa-eye" aria-hidden="true"></i>
                </button>
              )}

              {/* Edit User Details Trigger Button */}
              {accessPerm(72, 2) && (
                <button
                  className="btn btn-primary btn-sm"
                  title="Edit"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/dashboard/patient-info/edit`, {
                      state: {
                        record: original,
                      },
                    });
                  }}
                  style={{ marginRight: "5px" }}
                >
                  <i className="fa fa-check" aria-hidden="true"></i>
                </button>
              )}
            </div>
          );
        },
      }),
    ],
    [accessPerm, userDetails]
  );

  const table = useReactTable({
    data: userDetails,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <>
      <div className="card patient-information patient-container">
        <div className="card-body">
          <div className="rounded">
            <div className="card shadow-none mb-3">
              <div className="border p-3 rounded">
                <div className="d-flex justify-content-between align-items-center">
                  <h6
                    className="mb-0 btn btn-danger text-white text-capitalize fw-bold p-0 m-0"
                    style={{ cursor: "default" }}
                  >
                    Patient Pre-Registration
                  </h6>
                </div>

                <div className="d-flex align-items-center">
                  <form
                    onSubmit={(e) => handlerOnSearch(e)}
                    className="col-sm-12"
                  >
                    <div className="d-flex flex-wrap">
                      <div className="p-1">
                        <label className="col-form-label">
                          From <span className="text-danger">*</span>
                        </label>
                        <div className="">
                          <input
                            type="date"
                            data-date-format="YYYY MM DD"
                            name="from_date"
                            defaultValue={format(new Date(), "yyyy-MM-dd")}
                            className="form-control medical-form-select py-2"
                            placeholder="Date Picker..."
                            required={regInputField ? false : true}
                            style={{ maxWidth: "200px" }}
                          />
                        </div>
                      </div>
                      <div className="p-1">
                        <label className="col-form-label">
                          To <span className="text-danger">*</span>
                        </label>
                        <div className="">
                          <input
                            type="date"
                            data-date-format="YYYY MM DD"
                            defaultValue={format(new Date(), "yyyy-MM-dd")}
                            name="to_date"
                            className="form-control medical-form-select py-2"
                            placeholder="Date Picker..."
                            required={regInputField ? false : true}
                            style={{ maxWidth: "200px" }}
                          />
                        </div>
                      </div>
                      <div className="p-1">
                        <label className="col-form-label">Status</label>
                        <div className="fw-light">
                          <select
                            className="form-select medical-form-select py-2"
                            name="status"
                            aria-label="Default select example"
                            style={{ maxWidth: "140px" }}
                          >
                            <option value={""}>Select Status</option>
                            <option value={1}>PROCESSING</option>
                            <option value={2}>FIT</option>
                            <option value={3}>UNFIT</option>
                            <option value={4}>HELD-UP</option>
                          </select>
                        </div>
                      </div>
                      <div className="p-1">
                        <label className="col-form-label">Introducer</label>
                        <div className="fw-light">
                          <Select
                            components={{ MenuList: VirtualizedMenuList }}
                            options={options}
                            placeholder="Select Introducer"
                            onChange={(selectedOptions) =>
                              handleSelect("introducer", selectedOptions)
                            }
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                color: "black",
                                width: 300,
                                maxWidth: 320,
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                color: "black",
                              }),
                            }}
                            isSearchable={true}
                            value={selectedValues.introducer}
                            name="introducer"
                          />
                        </div>
                      </div>
                      <div className=" p-1">
                        <label className="col-form-label tdt">
                          Registration No.
                        </label>
                        <div className="">
                          <input
                            style={{ width: "180px", height: "37px" }}
                            type="text"
                            onChange={(e) => setRegInputField(e.target.value)}
                            name="invoice_reg_mobile"
                            className="form-control medical-form-select py-2"
                          />
                        </div>
                      </div>
                      <div className="p-1 d-flex align-items-end justify-content-end gap-1">
                        <button
                          type="submit"
                          className="btn text-white bg-danger border border-3"
                        >
                          Search
                        </button>
                        <button
                          type="button"
                          className="btn btn-warning border border-3"
                          onClick={(e) => reset(e)}
                        >
                          Reset
                        </button>
                        {accessPerm(72, 23) && (
                          <button
                            type="button"
                            className="btn btn-success border border-3"
                            onClick={() => handlePDF()}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            Download PDF
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="patient-info-table-search">
              {/* Record Summery Container */}

              <div className="fit-unfit-status">
                <span className="fw-bolder">Record Summary &gt; </span>
                {/* <span className="text-success fw-bolder">{`FIT: ${statusCounts?.status2}`}</span>
                <span> | </span>
                <span className="text-danger fw-bolder">{`UNFIT: ${statusCounts?.status3}`}</span>
                <span> | </span>
                <span className="fw-bolder" style={{ color: "blue" }}>
                  {`HELD-UP: ${statusCounts?.status4}`}
                </span>
                <span> | </span>
                <span className="fw-bolder">{`Others: ${statusCounts?.status1}`}</span>
                <span> | </span> */}
                <span className="fw-bolder">{`Total: ${totalStatus}`}</span>
              </div>

              {/* Registration Summery Container */}
              <div className="reg-summary">
                <span className="me-1">Summary Of:</span>{" "}
                <span
                  className="text-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#country-summary-modal"
                >
                  Country
                </span>{" "}
                <span className="mx-1">|</span>
                <span
                  className="text-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#agency-summary-modal"
                >
                  Agency
                </span>{" "}
                <span className="mx-1">|</span>
                <span
                  className="text-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#repres-summary-modal"
                >
                  Representative
                </span>{" "}
              </div>
            </div>
            {loading ? (
              <Loading />
            ) : (
              <table
                className="table align-middle table-hover table-bordered mb-0 rounded"
                ref={pdfRef}
              >
                <thead className="bg-primary text-white">
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup?.id}>
                      {headerGroup?.headers?.map((header) => (
                        <th
                          key={header?.id}
                          className={`p-1`}
                          style={{ backgroundColor: "#095d7e" }}
                        >
                          {header?.isPlaceholder
                            ? null
                            : flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, i) => {
                    const {
                      original: {
                        user: {
                          status,
                          is_radiology_done,
                          is_pathology_done,
                          is_physical_done,
                        },
                      },
                    } = row;

                    const collection =
                      row?.original?.user?.user_collections?.map(
                        (collection) =>
                          collection.investigation_category
                            ?.investigation_group_id
                      );

                    const uniqueCollection = [...new Set(collection)];

                    const done =
                      (uniqueCollection?.length < 2 &&
                        (is_pathology_done ||
                          is_physical_done ||
                          is_radiology_done)) ||
                      (uniqueCollection?.length >= 2 &&
                        uniqueCollection?.length < 3 &&
                        (is_pathology_done ? 1 : 0) +
                          (is_physical_done ? 1 : 0) +
                          (is_radiology_done ? 1 : 0) >=
                          2) ||
                      (uniqueCollection?.length >= 3 &&
                        is_pathology_done &&
                        is_physical_done &&
                        is_radiology_done);

                    const rowClass = (() => {
                      if (status === 2) {
                        return done ? "text-success" : "";
                      } else if (status === 3) {
                        return done ? "text-danger" : "";
                      } else if (status === 4) {
                        return done ? "text-primary" : "";
                      } else {
                        return "text-dark";
                      }
                    })();
                    return (
                      <tr key={i} className={rowClass}>
                        {row.getVisibleCells().map((cell) => (
                          <td
                            key={cell.id}
                            className="p-1"
                            style={{ color: "#000000" }}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {/* Registration Summery Modal Body */}
      <div>
        <CountrySummaryModal countryWiseUsers={countryWiseUsers} />
        <AgencySummaryModal introducerWiseUsers={introducerWiseUsers} />
        <PackageSummaryModal packageWiseUsers={packageWiseUsers} />
        <RepresentativeSummeryModal
          representativeWiseUsers={representativeWiseUsers}
        />
      </div>
    </>
  );
};

export default PreRegistration;
